import { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../api';

// Check the API status every two minutes to avoid spamming the server.
const STATUS_POLL_INTERVAL_MS = 120000;

const useServerStatus = () => {
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    const check = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/status`);
        const newStatus =
          res.status === 200 && res.data && res.data.status === 'ok'
            ? 'online'
            : 'offline';
        setStatus((prev) => (prev === newStatus ? prev : newStatus));
      } catch (err) {
        setStatus((prev) => (prev === 'offline' ? prev : 'offline'));
      }
    };
    check();
    const interval = setInterval(check, STATUS_POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return status;
};

export default useServerStatus;
